

import { useEffect, useState } from "react"
import { ChartstwitsRepository } from "../../repository/ChartstwitsRepository";
import { useNavigate } from 'react-router-dom';

export function ProfileModel() {
    const apiModel = ChartstwitsRepository();

    const navigate = useNavigate();

    return{}
}
